import { useState } from 'react';
import { useFormikContext } from 'formik';
import { v4 as uuidv4 } from 'uuid';

import { SourceId } from '@/react/portainer/gitops/sources/types';

import { FormValues } from '../../types';

/**
 * Unselected source slots, shown after the picked sources. Seeded with one
 * so the step never opens empty; only ever grows via "Add source".
 */
export function useSourceSlots() {
  const { values, setValues } = useFormikContext<FormValues>();
  const [pendingSourceSlots, setPendingSourceSlots] = useState<Array<string>>(
    () => (values.sources.length > 0 ? [] : [uuidv4()])
  );

  return {
    pendingSourceSlots,
    addSourceSlot,
    removePendingSlot,
    selectPendingSource,
    removeSource,
  };

  function addSourceSlot() {
    setPendingSourceSlots((prev) => [...prev, uuidv4()]);
  }

  function removePendingSlot(key: string) {
    setPendingSourceSlots((prev) => prev.filter((slotKey) => slotKey !== key));
  }

  function selectPendingSource(key: string, sourceId: SourceId) {
    setPendingSourceSlots((prev) => prev.filter((slotKey) => slotKey !== key));
    setValues((prev) => ({
      ...prev,
      sources: [...prev.sources, sourceId],
    }));
  }

  // Only files from the removed source are dropped; files from other
  // sources in the same artifact are left untouched.
  function removeSource(sourceId: SourceId) {
    setValues((prev) => ({
      ...prev,
      sources: prev.sources.filter((id) => id !== sourceId),
      artifacts: prev.artifacts.map((artifact) => ({
        ...artifact,
        files: artifact.files.filter((file) => file.sourceId !== sourceId),
      })),
    }));
  }
}
